module.exports = __webpack_public_path__ + "img/karty_bdo.7afd8ff7.svg";